import { render } from "./InputConfirm.vue?vue&type=template&id=32d0c410"
import script from "./InputConfirm.vue?vue&type=script&lang=js"
export * from "./InputConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script